
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EsignatureInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addEsignature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"birthday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"birthplace"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"user_address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"user_inn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"passport"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"passport_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"passport_place"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"passport_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"user_phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_inn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sms_key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sms_phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sms_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"user_ip"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"esignature_id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":317}};
    doc.loc.source = {"body":"mutation ($input: EsignatureInput!) {\n  addEsignature (input: $input) {\n    id\n    name\n    birthday\n    birthplace\n    user_address\n    user_inn\n    passport\n    passport_date\n    passport_place\n    passport_code\n    user_phone\n    company_inn\n    sms_key\n    sms_phone\n    sms_date\n    user_ip\n\t\tesignature_id\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
